"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.promise");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.promise");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.array.is-array");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.array.for-each");

var _axios = _interopRequireDefault(require("axios"));

var cart = _interopRequireWildcard(require("@shopify/theme-cart"));

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("./utils");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}
/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-ajax-cart="container"]',
  addToCart: '[js-ajax-cart="addToCart"]',
  clearCart: '[js-ajax-cart="clearCart"]',
  remove: '[js-ajax-cart="remove"]',
  lineItem: '[js-ajax-cart="lineItem"]',
  form: '[js-ajax-cart="form"]',
  cartCounter: '[js-ajax-cart="cartCounter"]',
  subscriptionProductInCart: '[js-subscription-in-cart="message"]'
};
/**
 * Export a new AjaxCart instance
 * @param {object} config - Settings to apply across all Ajax calls to the cart.
 */

/**
 * Stores the timeout ID for the subscription error message timer.
 */

var messageTimeout = null;

var _default = function _default(config) {
  /**
   * @param {number} formId - The ID of the product to check.
   * @returns {Promise<boolean>} - Resolves to true if the product exists, otherwise false.
   */
  var isProductInCart = function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(formId) {
      var response, items;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _axios["default"].get('/cart.json');

            case 3:
              response = _context.sent;
              items = response.data.items;

              if (!(!items || !Array.isArray(items))) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", false);

            case 7:
              return _context.abrupt("return", items.some(function (item) {
                var isSameProduct = item.id === formId;
                var isSubscription = Boolean(item.selling_plan_allocation);
                return isSameProduct && isSubscription;
              }));

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              window.console.error(_context.t0);
              return _context.abrupt("return", false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function isProductInCart(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  /**
   * Handle add to cart event and set loading state.
   * @param {object} event - Click and key down event.
   */


  var handleAddToCart = function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(event) {
      var target, formData, formObject, formId, exists, response;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(isKeyDownEvent(event) && !isKeyPressIsEnter(event))) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              event.preventDefault();
              target = event.currentTarget;

              if (!requestInProgress) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return");

            case 6:
              requestInProgress = true;
              setLoadingState(target);
              formData = new FormData(target.closest('form'));
              formObject = {};
              formData.forEach(function (value, key) {
                formObject[key] = value;
              });
              formId = Number(formObject.id);
              _context2.prev = 12;
              _context2.next = 15;
              return isProductInCart(formId);

            case 15:
              exists = _context2.sent;

              if (!exists) {
                _context2.next = 22;
                break;
              } // If the product is a subscription and already in the cart, do not add it again


              setDefaultState(target);

              if (messageTimeout) {
                clearTimeout(messageTimeout);
                messageTimeout = null;
              }

              if (nodeSelectors.subscriptionProductInCart) {
                nodeSelectors.subscriptionProductInCart.innerHTML = "".concat(theme.strings.productInCart);
                messageTimeout = setTimeout(function () {
                  nodeSelectors.subscriptionProductInCart.innerHTML = '';
                  messageTimeout = null;
                }, 5000);
              }

              requestInProgress = false;
              return _context2.abrupt("return");

            case 22:
              _context2.next = 24;
              return _axios["default"].post('/cart/add.js', (0, _utils.serialize)(target.closest('form')));

            case 24:
              response = _context2.sent;
              Frame.EventBus.emit('AjaxCart:itemAdded', response);

              if (nodeSelectors.subscriptionProductInCart) {
                nodeSelectors.subscriptionProductInCart.innerHTML = '';
              }

              setDefaultState(target);
              executeCallback();
              _context2.next = 35;
              break;

            case 31:
              _context2.prev = 31;
              _context2.t0 = _context2["catch"](12);
              window.console.error(_context2.t0);
              setDefaultState(target);

            case 35:
              _context2.prev = 35;
              requestInProgress = false;
              return _context2.finish(35);

            case 38:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[12, 31, 35, 38]]);
    }));

    return function handleAddToCart(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  /**
  * Set remove item events.
  */

  /**
   * Node selectors.
   */


  var nodeSelectors = {
    addToCart: _toConsumableArray(document.querySelectorAll(selectors.addToCart)),
    cartCounter: document.querySelector(selectors.cartCounter),
    clearCart: _toConsumableArray(document.querySelectorAll(selectors.clearCart)),
    container: _toConsumableArray(document.querySelectorAll(selectors.container)),
    subscriptionProductInCart: document.querySelector(selectors.subscriptionProductInCart)
  };
  /**
  * Initialise component.
  */

  function init() {
    setListeners();
    setAddToCartEvents();
    setClearCartEvents();
    setRemoveEvents();
  }
  /**
   * Set listeners.
   */


  function setListeners() {
    /**
     * Reinitialise Ajax cart on call.
     */
    Frame.EventBus.listen(['AjaxCart:init', 'AjaxCart:reinit'], function () {
      setRemoveEvents();
    });
    /**
     * React to any item changes in the cart.
     */

    Frame.EventBus.listen(['AjaxCart:itemAdded', 'AjaxCart:itemRemoved', 'AjaxCart:itemUpdated', 'AjaxCart:cartCleared'], function (response) {
      updateCounter();

      if (response.item_count <= 0) {
        Frame.EventBus.emit('AjaxCart:cartEmpty', response);
      }
    });
    /**
     * Global helper function to add items to cart and trigger
     * responses and linked interactions.
     */

    Frame.EventBus.listen('AjaxCart:addItem', function (_ref) {
      var id = _ref.id,
          options = _ref.options;
      cart.addItem(id, options).then(function (response) {
        return Frame.EventBus.emit('AjaxCart:itemAdded', response);
      })["catch"](function (error) {
        window.console.error(error);
        return error;
      });
    });
    Frame.EventBus.listen('AjaxCart:removeItem', function (key) {
      cart.removeItem(key).then(function (response) {
        return Frame.EventBus.emit('AjaxCart:itemRemoved', response);
      })["catch"](function (error) {
        window.console.error(error);
        return error;
      });
    });
  }
  /**
  * Set click events on buttons to post form data.
  */


  function setAddToCartEvents() {
    nodeSelectors.addToCart.forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return handleAddToCart(event);
      });
      (0, _utils.on)('keydown', element, function (event) {
        return handleAddToCart(event);
      });
    });
  }

  var requestInProgress = false;

  function setRemoveEvents() {
    _toConsumableArray(document.querySelectorAll(selectors.remove)).forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return handleRemoveEvent(event);
      });
      (0, _utils.on)('keydown', element, function (event) {
        return handleRemoveEvent(event);
      });
    });
  }
  /**
   * Handle remove event.
   * @param {Event} event - Click/keydown event object.
   */


  function handleRemoveEvent(event) {
    event.preventDefault();

    if (isKeyDownEvent(event) && !isKeyPressIsEnter(event)) {
      return;
    }

    var key = event.currentTarget.dataset.key;

    if (!key) {
      return;
    }

    Frame.EventBus.emit('AjaxCart:removingItem', event.currentTarget.closest(selectors.lineItem));

    _axios["default"].get('/cart.js').then(function (cartResponse) {
      var item = cartResponse.data.items.find(function (cartItem) {
        return cartItem.key === key;
      });

      if (!item) {
        throw new Error('No matching item found.');
      }

      return cart.removeItem(key);
    }).then(function (response) {
      Frame.EventBus.emit('AjaxCart:itemRemoved', response);
      return response;
    })["catch"](function (error) {
      return error;
    });
  }
  /**
   * Check if key down event.
   * @param {Event} event - Keydown event object.
   */


  function isKeyDownEvent(event) {
    return event.type === 'keydown';
  }
  /**
   * Check if the return key is pressed.
   * @param {Event} event - Key code event.
   */


  function isKeyPressIsEnter(event) {
    return event.which === 13;
  }
  /**
   * Set clear cart events if enabled.
   */


  function setClearCartEvents() {
    if (!nodeSelectors.clearCart) {
      return;
    }

    nodeSelectors.clearCart.forEach(function (element) {
      (0, _utils.on)('click', element, function (event) {
        return clearItems(event);
      });
    });
  }
  /**
   * Handle clear cart events.
   * @param {Event} event - Click/keydown event object.
   */


  function clearItems(event) {
    event.preventDefault();
    cart.clearItems().then(function (response) {
      Frame.EventBus.emit('AjaxCart:cartCleared', response);
      return response;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }
  /**
   * Update cart counter.
   */


  function updateCounter() {
    _axios["default"].get('/cart.js').then(function (response) {
      renderCartCounter(response.data);
      return response.data.item_count;
    })["catch"](function (error) {
      window.console.error(error);
      return error;
    });
  }
  /**
   * Render cart counter.
   * @param {Object} response - Cart.json data.
   */


  function renderCartCounter(response) {
    if (!nodeSelectors.cartCounter) {
      return;
    }

    nodeSelectors.cartCounter.classList.remove(_cssClasses["default"].hidden);
    nodeSelectors.cartCounter.innerText = response.item_count;

    if (response.item_count <= 0) {
      nodeSelectors.cartCounter.classList.add(_cssClasses["default"].hidden);
    }
  }
  /**
   * Set loading state.
   * @param {object} target clicked add to cart button in DOM.
   */


  function setLoadingState(target) {
    _toConsumableArray(nodeSelectors.addToCart).forEach(function (element) {
      if (target === element) {
        element.innerText = theme.strings.addingToCart;
      }
    });
  }
  /**
  * Reset the loading states back to default.
  * @param {object} target clicked add to cart button in DOM.
  */


  function setDefaultState(target) {
    _toConsumableArray(nodeSelectors.addToCart).forEach(function (element) {
      if (target === element) {
        if (target.getAttribute('data-preorder')) {
          element.innerText = theme.strings.preOrder;
        } else {
          element.innerText = theme.strings.addToCart;
        }
      }
    });
  }
  /**
   * Execute callback function defined in constructor.
   */


  function executeCallback() {
    return _typeof(config) === 'object' && config.callback === 'function' ? config.callback() : false;
  }
  /**
   * Public interface.
   */


  return Object.freeze({
    init: init
  });
};

exports["default"] = _default;